module.exports = __webpack_public_path__ + "static/media/ope_saara_480x640.419a51f4.jpg";